import { createSlice } from '@reduxjs/toolkit';
import { RootState, SessionState } from './types';

const initialState: SessionState = {
  user: null,
  documentId: null,
  sessionPatientId: null,
  shortCode: null,
  wasReferredByZocdoc: null,
  referralSource: null,
  isGuardian: null,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setDocumentId: (state, action) => {
      state.documentId = action.payload;
    },
    setSessionPatientId: (state, action) => {
      state.sessionPatientId = action.payload;
    },
    setShortCode: (state, action) => {
      state.shortCode = action.payload;
    },
    setWasReferredByZocdoc: (state, action) => {
      state.wasReferredByZocdoc = action.payload;
    },
    setIsGuardian: (state, action) => {
      state.isGuardian = action.payload;
    },
    setReferralSource: (state, action) => {
      state.referralSource = action.payload;
    },
  },
});

export const {
  setUser,
  setDocumentId,
  setSessionPatientId,
  setShortCode,
  setWasReferredByZocdoc,
  setIsGuardian,
  setReferralSource,
} = sessionSlice.actions;

export const selectSessionPatientId = (state: RootState) =>
  state.session.sessionPatientId;
export const selectShortCode = (state: RootState) => state.session.shortCode;
export const selectUser = (state: RootState) => state.session.user;
export const selectIsGuardian = (state: RootState) => state.session.isGuardian;
export const selectReferralSource = (state: RootState) =>
  state.session.referralSource;

export default sessionSlice.reducer;
